import type { PickStateRefValues } from '@wix/editor-elements-integrations';
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ICustomElementComponentProps,
  CustomElementComponentControllerProps,
  ICustomElementComponentMapperProps,
} from '../types';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';
import { shouldSanitizeSpec } from '../constants';

export default withCompController<
  ICustomElementComponentMapperProps,
  CustomElementComponentControllerProps,
  ICustomElementComponentProps,
  PickStateRefValues<'experiments'>
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { experiments } = stateValues;
  const shouldSanitize = isExperimentOpen(experiments, shouldSanitizeSpec);
  const { updateStyles } = controllerUtils;
  return {
    ...mapperProps,
    shouldSanitize,
    fixHeight: ({ height }) => {
      if (height > 0) {
        updateStyles({
          '--custom-element-height': `${height}px !important`,
          '--custom-element-min-height': `auto !important`,
        });
      }
    },
    updateMinHeight: ({ height }) => {
      updateStyles({
        '--custom-element-min-height': `${height}px !important`,
      });
    },
  };
});
